import { ADDITIONAL_VENTURE_LINK } from "constants/global";
import { StyledLink } from "./styles";

export const aboutSourceContent = {
  title: 'About SOURCE',
  joinNowBtnText: 'Join Now',
  description: (
    <>
      SOURCE is a research study to catalyze the discovery of targeted, transformative treatments and cures for single ventricle heart defects by building the largest genetic dataset of patients and families, equipping researchers to better understand the genetics and biology of single ventricle heart disease and the related complications. Through SOURCE, we will collect health and genetic information from thousands of people with single ventricle heart defects and their family members. We will make the de-identified data, which excludes all personally identifying information, available to all researchers at no cost, through a simple application process. The data will enable researchers to uncover the causes of single ventricle heart defects and the related health issues many people with these conditions develop. In this way, SOURCE is more than just one study – it is many studies! Our goal is to drive as much research as possible as quickly as possible, while carefully protecting the privacy of study participants.
      <br />
      <br />
      We are deeply committed to supporting research that will lead to better single ventricle treatments and someday even cures for all single ventricle patients – including those alive today and those not yet born. We believe the research that will come out of SOURCE can create a future of hope and possibility, where single ventricle heart defects no longer determine a person’s length or quality of life, where their causes are no longer a mystery, and where patients have access to cures and treatments customized to their personal genetics and biology.   
    </>
  )
};

export const whoWeAreContent = {
  title: 'Who We Are',
  description: (
    <>
      SOURCE is powered by{' '}
      <StyledLink to={ADDITIONAL_VENTURE_LINK}>
      Additional Ventures
      </StyledLink>
      , a nonprofit organization that funds research to improve the lives of those with single ventricle heart disease. Additional Ventures’ mission is to cure single ventricle heart disease for all patients – those alive today and those born in the future -- through transformative research and strategic investments that revolutionize treatment and care. Since its founding in 2020, Additional Ventures has invested approximately $20M annually towards uncovering single ventricle biology, advancing new therapies, and driving the single ventricle research community towards a cure.
    </>
  )
};

export const ourNetworksContent = {
  title: 'Our Network',
  description: `We can’t do this alone. Additional Ventures is working with Boston
          Children’s Hospital, IQVIA, Gencove, Gene by Gene, and Grey Genetics to carry out
          SOURCE.`
};

export const ourClinicalSitesContent = {
  title: 'Our Clinical Sites',
  description: [`We know not everyone is able to sign up online.  We have partnered with clinical sites to assist in participant recruitment and enrollment.`,
          'We are excited to be currently enrolling at Boston Children’s Hospital.  More in-clinic enrollment sites coming soon!']
};